export class VerificationTestasFormDto {
    participantNumber: string;
    participantName: string;
    dateOfBirth: string; // yyyy-mm-dd
    examDate: string; // yyyy-mm-dd
    kernPr: string;
    kernScore: string;
    kernStandard: string;
    fachPr: string;
    fachScore: string;
    fachStandard: string;
    fachmodul: string;
}
